import { BaseApiClient } from "../base-api-client";
export class StockNewsClient extends BaseApiClient {
    constructor(config) {
        super({
            ...config,
            baseURL: `${config.baseURL}/stock-news`,
        }, "StockNewsClient");
    }
    async getStockNews(userId, options) {
        const queryParams = new URLSearchParams();
        if (options?.limit)
            queryParams.append("limit", String(options.limit));
        if (options?.page)
            queryParams.append("page", String(options.page));
        const query = queryParams.toString();
        const response = await this.get(`/${userId}${query ? `?${query}` : ""}`);
        if (!response.success || !response.data) {
            throw new Error(response.error || "Failed to get stock news");
        }
        return response.data;
    }
    async getStockInstruments() {
        const response = await this.get("/instruments");
        if (!response.success) {
            throw new Error(response.error || "Failed to get stock instruments");
        }
        return response.data ?? [];
    }
}
//# sourceMappingURL=stock-news-client.js.map